module.exports = __webpack_public_path__ + "img/HealthHelp_SecureChat.1095067d.svg";